import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function LinkSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.023 11.118l2.475-2.475c1.061-1.06 1.556-2.687 1.273-4.384-.07-1.06-.566-1.98-1.343-2.758C17.72.794 16.73.37 15.67.158a5.068 5.068 0 00-4.243 1.414L7.892 5.108c-.99.99-1.485 2.474-1.414 3.677.07 1.202.565 2.262 1.414 3.11.353.354.707.708 1.202.92.353.212.778.07.99-.283.212-.353.07-.778-.283-.99-.283-.141-.566-.283-.849-.565-.636-.637-.99-1.415-1.06-2.192-.142-.99.283-1.98.99-2.687l3.535-3.536c.778-.778 1.839-1.131 2.97-.99.778.07 1.485.495 1.98.99.566.566.849 1.273.99 1.98.141 1.131-.212 2.192-.99 2.97l-2.475 2.475c-.353.353-.353.777 0 1.131a.789.789 0 001.131 0zM8.67 18.472l3.535-3.536c1.91-1.909 1.839-5.09-.212-6.859-.354-.353-.707-.707-1.202-.919-.354-.212-.778-.07-.99.283-.212.354-.07.778.283.99l.176.104c.274.16.509.298.743.532 1.344 1.344 1.344 3.607 0 4.95l-3.465 3.465c-.636.636-1.414.99-2.404.99a3.492 3.492 0 01-2.404-.99c-1.414-1.414-1.344-3.606 0-4.95l2.616-2.616c.354-.354.354-.778 0-1.132a.789.789 0 00-1.131 0l-2.616 2.617c-1.98 1.98-1.91 5.162 0 7.07.919.92 2.262 1.415 3.535 1.415 1.344.07 2.616-.495 3.536-1.414z",
    clipRule: "evenodd"
  }));
}

export default LinkSmall;
//# sourceMappingURL=LinkSmall.js.map